<template>
  <div class="container client">
    <div class="header card">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>设置</el-breadcrumb-item>
        <el-breadcrumb-item>运费模板</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">编辑模板</h2>
        </div>
      </div>
    </div>
    <div class="results card">
      <div class="values-header">
        <p class="title">模板设置</p>
      </div>
      <div class="contents">
        <el-form class="dataForm"
                 :model="dataForm"
                 :rules="rules"
                 ref="dataForm"
                 label-width="150px">
          <el-form-item label="模板名称"
                        prop="name">
            <el-input v-model="dataForm.name"
                      placeholder="请输入模板名称"></el-input>
          </el-form-item>

          <el-form-item label="配送区域"
                        prop="province_name">
            <div class="values">
              <el-table class="table"
                        :data="results"
                        style="width: 100%">
                <el-table-column label="可配送区域"
                                 min-width="300"
                                 align="center"
                                 prop="province_name">
                </el-table-column>
                <el-table-column prop="scope.row.price_single_item"
                                 label="运费(元)"
                                 width="200"
                                 align="center">
                  <template scope="scope">
                    <el-input v-model="scope.row.price_single_item"
                              @change="inputChage(scope.row)"
                              :precision="2"
                              :step="0.1"
                              :max="10"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="操作"
                                 width="200"
                                 align="center"
                                 fixed="right">
                  <template slot-scope="scope">
                    <el-button size="mini"
                               type="text"
                               @click="handleToPaperEdit(scope.row, scope.$index)">编辑</el-button>
                    <el-button size="mini"
                               type="text"
                               @click="handleToItemsCancle(scope.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>

              <div class="addArea"
                   @click="addAreaCilck()">
                添加可配送区域和运费
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="bt_bottom">
        <div class="save"
             @click="handleSave()">保存</div>
        <div class="cancle"
             @click="cancleSave()">取消</div>
      </div>
    </div>

    <!-- 添加可以配送弹窗 -->
    <el-dialog title=""
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               width="700px">
      <div class="dialog_top">选择配送区域</div>
      <div class="intent--wrapper">
        <div class="class-category"
             v-for="(firItem, firIndex) in areaList"
             :key="firIndex">
          <div class="intent-course-header">
            <el-checkbox v-model="firItem.mychecked"
                         @change="firstChanged(firIndex)"></el-checkbox>
            {{firItem.area}}
          </div>
          <div class="details">
            <div class="class-details"
                 v-for="(subItem, subIndex) in firItem.list"
                 :key="subIndex">
              <el-checkbox v-model="subItem.mychecked"
                           @change="secondChanged(firIndex)"></el-checkbox>
              <span>{{subItem.name}}</span>
            </div>
          </div>
        </div>
        <div class="purchase-course">
          <el-checkbox v-model="allChecked"
                       @change="handleSelectAllClassfiy">全选</el-checkbox>
          <div class="bt">
            <div class="btCancle"
                 @click="toCancle()">取消</div>
            <div class="btConfirm"
                 @click="toConfirm()">确定</div>
          </div>
        </div>

      </div>
    </el-dialog>
  </div>

</template>
<script>
import { expressTemplateDetail, expressTemplateUpate } from '@/api/index.js'

export default {
  // 全选功能
  allChecked: {
    get() {
      let count = 0
      for (let i = 0; i < this.areaList.length; i += 1) {
        if (this.areaList[i].mychecked === true) {
          count += 1
        } else {
          count -= 1
        }
      }
      if (count === this.areaList.length) {
        return true
      }
      return false
    },
    set(val) {
      return val
    },
  },
  data() {
    return {
      ids: 0,
      addId: 0,
      rowbiao: {},
      biao: 0,
      biaoId: null,
      editCity: [],
      price: 0,
      index: 0,
      name: [],
      code: [],
      dialogVisible: false,
      dataForm: { name: '' },
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
      },
      checkAll: false,
      checkedCities: [],
      isIndeterminate: false,
      results: [],
      areaList: [
        {
          area: '华东地区',
          mychecked: false,
          list: [
            {
              id: 9,
              name: '上海市',
              code: '31',
              area: '华东地区',
              alias: '上海',
              college_count: 84,
              mychecked: false,
            },
            {
              id: 10,
              name: '江苏省',
              code: '32',
              area: '华东地区',
              alias: '江苏',
              college_count: 177,
              mychecked: false,
            },
            {
              id: 11,
              name: '浙江省',
              code: '33',
              area: '华东地区',
              alias: '浙江',
              college_count: 111,
              mychecked: false,
            },
            {
              id: 12,
              name: '安徽省',
              code: '34',
              area: '华东地区',
              alias: '安徽',
              college_count: 122,
              mychecked: false,
            },
            {
              id: 13,
              name: '福建省',
              code: '35',
              area: '华东地区',
              alias: '福建',
              college_count: 90,
              mychecked: false,
            },
            {
              id: 14,
              name: '江西省',
              code: '36',
              area: '华东地区',
              alias: '江西',
              college_count: 107,
              mychecked: false,
            },
            {
              id: 15,
              name: '山东省',
              code: '37',
              area: '华东地区',
              alias: '山东',
              college_count: 158,
              mychecked: false,
            },
          ],
        },
        {
          area: '华中地区',
          mychecked: false,
          list: [
            {
              id: 16,
              name: '河南省',
              code: '41',
              area: '华中地区',
              alias: '河南',
              college_count: 163,
              mychecked: false,
            },
            {
              id: 17,
              name: '湖北省',
              code: '42',
              area: '华中地区',
              alias: '湖北',
              college_count: 149,
              mychecked: false,
            },
            {
              id: 18,
              name: '湖南省',
              code: '43',
              area: '华中地区',
              alias: '湖南',
              college_count: 131,
              mychecked: false,
            },
          ],
        },
        {
          area: '华南地区',
          mychecked: false,
          list: [
            {
              id: 19,
              name: '广东省',
              code: '44',
              area: '华南地区',
              alias: '广东',
              college_count: 164,
              mychecked: false,
            },
            {
              id: 20,
              name: '广西',
              code: '45',
              area: '华南地区',
              alias: '广西',
              college_count: 85,
              mychecked: false,
            },
            {
              id: 21,
              name: '海南省',
              code: '46',
              area: '华南地区',
              alias: '海南',
              college_count: 21,
              mychecked: false,
            },
          ],
        },
        {
          area: '华北地区',
          mychecked: false,
          list: [
            {
              id: 1,
              name: '北京市',
              code: '11',
              area: '华北地区',
              alias: '北京',
              college_count: 187,
              mychecked: false,
            },
            {
              id: 2,
              name: '天津市',
              code: '12',
              area: '华北地区',
              alias: '天津',
              college_count: 61,
              mychecked: false,
            },
            {
              id: 3,
              name: '河北省',
              code: '13',
              area: '华北地区',
              alias: '河北',
              college_count: 125,
              mychecked: false,
            },
            {
              id: 4,
              name: '山西省',
              code: '14',
              area: '华北地区',
              alias: '山西',
              college_count: 85,
              mychecked: false,
            },
          ],
        },
        {
          area: '西北地区',
          mychecked: false,
          list: [
            {
              id: 5,
              name: '内蒙古',
              code: '15',
              area: '西北地区',
              alias: '内蒙古',
              college_count: 54,
              mychecked: false,
            },
            {
              id: 27,
              name: '陕西省',
              code: '61',
              area: '西北地区',
              alias: '陕西',
              college_count: 124,
              mychecked: false,
            },
            {
              id: 28,
              name: '甘肃省',
              code: '62',
              area: '西北地区',
              alias: '甘肃',
              college_count: 51,
              mychecked: false,
            },
            {
              id: 29,
              name: '青海省',
              code: '63',
              area: '西北地区',
              alias: '青海',
              college_count: 12,
              mychecked: false,
            },
            {
              id: 30,
              name: '宁夏',
              code: '64',
              area: '西北地区',
              alias: '宁夏',
              college_count: 20,
              mychecked: false,
            },
            {
              id: 31,
              name: '新疆',
              code: '65',
              area: '西北地区',
              alias: '新疆',
              college_count: 54,
              mychecked: false,
            },
          ],
        },
        {
          area: '东北地区',
          mychecked: false,
          list: [
            {
              id: 6,
              name: '辽宁省',
              code: '21',
              area: '东北地区',
              alias: '辽宁',
              college_count: 113,
              mychecked: false,
            },
            {
              id: 7,
              name: '吉林省',
              code: '22',
              area: '东北地区',
              alias: '吉林',
              college_count: 71,
              mychecked: false,
            },
            {
              id: 8,
              name: '黑龙江省',
              code: '23',
              area: '东北地区',
              alias: '黑龙江',
              college_count: 88,
              mychecked: false,
            },
          ],
        },

        {
          area: '西南地区',
          mychecked: false,
          list: [
            {
              id: 22,
              name: '重庆市',
              code: '50',
              area: '西南地区',
              alias: '重庆',
              college_count: 73,
              mychecked: false,
            },
            {
              id: 23,
              name: '四川省',
              code: '51',
              area: '西南地区',
              alias: '四川',
              college_count: 147,
              mychecked: false,
            },
            {
              id: 24,
              name: '贵州省',
              code: '52',
              area: '西南地区',
              alias: '贵州',
              college_count: 75,
              mychecked: false,
            },
            {
              id: 25,
              name: '云南省',
              code: '53',
              area: '西南地区',
              alias: '云南',
              college_count: 83,
              mychecked: false,
            },

            {
              id: 26,
              name: '西藏',
              code: '54',
              area: '西南地区',
              alias: '西藏',
              college_count: 7,
              mychecked: false,
            },
          ],
        },
        {
          area: '台湾',
          mychecked: false,
          list: [
            {
              id: 32,
              name: '台湾省',
              code: '71',
              area: '',
              alias: '台湾',
              college_count: 0,
              mychecked: false,
            },
          ],
        },
        {
          area: '香港特别行政区',
          mychecked: false,
          list: [
            {
              id: 33,
              name: '香港',
              code: '81',
              area: '',
              alias: '香港特别行政区',
              college_count: 0,
              mychecked: false,
            },
          ],
        },
        {
          area: '澳门特别行政区',
          mychecked: false,
          list: [
            {
              id: 34,
              name: '澳门',
              code: '82',
              area: '',
              alias: '澳门特别行政区',
              college_count: 0,
              mychecked: false,
            },
          ],
        },
      ],
    }
  },
  created() {
    this.ids = this.$route.query.id
    let data = {
      id: this.$route.query.id,
    }
    expressTemplateDetail(data).then((res) => {
      this.dataForm.name = res.name
      res.arr_single_price.map((item) => {
        this.results.push({
          id: this.index,
          province_name: item.province_codes.split(','),
          province_codes: item.province_codes,
          price_single_item: item.price_single_item,
        })
        this.index = this.index + 1
      })
      let provinceNamecode = []
      this.areaList.map((item) => {
        item.list.map((t) => {
          provinceNamecode.push({
            code: t.code,
            name: t.name,
          })
        })
      })
      // 创建一个从 code 到 name 的映射表
      const codeToNameMap = provinceNamecode.reduce((acc, item) => {
        acc[item.code] = item.name
        return acc
      }, {})

      // 遍历 t 数组并映射 y 数组
      this.results.forEach((item) => {
        item.province_name = item.province_name.map(
          (code) => codeToNameMap[code]
        )
      })
      this.results.forEach((item) => {
        if (Array.isArray(item.province_name)) {
          item.province_name = item.province_name.join(',')
        }
      })
    })
  },
  methods: {
    inputChage() {},
    handleToItemsCancle(row) {
      this.results.map((item) => {
        if (item.id == row.id) {
          this.results.splice(item.id, 1)
        }
      })
    },
    toCancle() {
      this.dialogVisible = false
    },
    handleToPaperEdit(row, index) {
      this.rowbiao = row
      this.biaoId = index
      this.biao = 1
      this.areaList.map((item) => {
        item.mychecked = false
        item.list.map((k) => {
          k.mychecked = false
        })
      })
      this.areaList.map((item) => {
        item.list.map((k) => {
          row.province_name.split(',').map((y) => {
            if (k.name == y) {
              k.mychecked = true
            }
          })
        })
      })
      this.dialogVisible = true
    },
    toConfirm() {
      this.checkedCities = []
      this.areaList.map((item) => {
        item.list.map((k) => {
          if (k.mychecked == true) {
            this.checkedCities.push(k)
          }
        })
      })
      this.checkedCities.map((i) => {
        this.name.push(i.name)
        this.code.push(i.code)
      })
      if (this.biao == 0) {
        this.results[this.index] = {
          province_name: this.name.join(','),
          province_codes: this.code.join(','),
          price_single_item: 0,
          id: this.index,
        }
        this.results = [...this.results]
      } else if (this.biao == 1) {
        this.results[this.biaoId] = {
          province_name: this.name.join(','),
          province_codes: this.code.join(','),
          price_single_item: this.rowbiao.price_single_item,
          id: this.rowbiao.id,
        }
        this.results = [...this.results]
      }
      this.index = this.index + 1
      this.name = []
      this.code = []
      this.dialogVisible = false
    },
    // 一级change事件
    firstChanged(index) {
      // console.log('一级选中区域', index)
      const { list } = this.areaList[index]
      if (this.areaList[index].mychecked === false) {
        list.forEach((item) => {
          this.$set(item, 'mychecked', false)
        })
      } else {
        list.forEach((item) => {
          this.$set(item, 'mychecked', true)
        })
      }
    },
    // 二级change事件
    secondChanged(index) {
      const subData = this.areaList[index].list
      let tickCount = 0
      const len = subData.length
      for (let i = 0; i < len; i += 1) {
        if (subData[i].mychecked === true) {
          tickCount += 1
        } else {
          tickCount -= 1
        }
      }
      if (tickCount === len) {
        // 二级全勾选  一级勾选
        this.$set(this.areaList[index], 'mychecked', true)
      } else {
        // 二级未全选  一级不勾选
        this.$set(this.areaList[index], 'mychecked', false)
      }
    },
    // 总的全选
    handleSelectAllClassfiy(val) {
      if (val) {
        for (let i = 0; i < this.areaList.length; i += 1) {
          this.areaList[i].mychecked = true
          this.firstChanged(i) // 调用一级change事件
        }
      } else {
        for (let i = 0; i < this.areaList.length; i += 1) {
          this.areaList[i].mychecked = false
          this.firstChanged(i) // 调用一级change事件
        }
      }
    },
    addAreaCilck() {
      this.biao = 0
      this.addId = 1
      this.areaList.map((item) => {
        item.mychecked = false
        item.list.map((k) => {
          k.mychecked = false
        })
      })
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
    },
    handleSave() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          let arr_single_price = []
          this.results.map((item) => {
            arr_single_price.push({
              province_codes: item.province_codes,
              price_single_item: item.price_single_item,
            })
          })
          let data = {
            id: this.ids,
            name: this.dataForm.name,
            price_type: 1,
            arr_single_price: arr_single_price,
          }
          expressTemplateUpate(data).then((res) => {
            this.$message.success(`修改成功`)
            this.$router.push(`/freight`)
          })
        }
      })
    },
    cancleSave() {
      this.$router.push(`/freight`)
    },
  },
}
</script>
<style lang="less" scoped>
.intent--wrapper {
  width: 100%;
  height: 550px;
  .class-category {
    width: 100%;
    display: flex;
    justify-content: flex-start;

    .intent-course-header {
      width: 150px;
    }
    .details {
      width: 80%;
      height: 50px;

      display: flex;
      justify-content: flex-start;

      .class-details {
        width: 77px;
        span {
          margin-left: 6px;
        }
      }
    }
  }
  .purchase-course {
    display: flex;
    justify-content: space-between;
    .bt {
      width: 150px;
      display: flex;
      justify-content: space-between;
      .btCancle {
        cursor: pointer;
        width: 56px;
        height: 32px;
        text-align: center;
        line-height: 32px;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #dcdfe6;
      }
      .btConfirm {
        cursor: pointer;
        text-align: center;
        color: #ffffff;
        width: 56px;
        height: 32px;
        text-align: center;
        line-height: 32px;
        background: #409eff;
        border-radius: 4px 4px 4px 4px;
      }
    }
  }
}

::v-deep .el-form-item__label {
  text-align: left !important;
  padding-left: 30px !important;
}
::v-deep .el-form-item__content {
  margin-left: 150px !important;
}
.client {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;
    }
  }
  .results {
    flex: 1;
    margin-top: 27px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .avatar {
      display: block;
      width: 68px;
      height: 68px;
      object-fit: cover;
      margin: 0 auto;
    }
    .footer {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
    }
  }

  .contents {
    width: 50%;
    min-height: 270px;
    border-bottom: 1px solid #eeeeee;
  }
  .addArea {
    cursor: pointer;
    margin-top: 11px;
    color: #409eff;
    text-align: center;
    line-height: 36px;
    width: 100%;
    height: 36px;
    border-radius: 4px 4px 4px 4px;
    border: 1px dashed #409eff;
  }
  .bt_bottom {
    margin-top: 24px;
    width: 150px;
    height: 32px;
    display: flex;
    justify-content: space-between;
    .save {
      cursor: pointer;
      text-align: center;
      font-size: 14px;
      color: #ffff;
      width: 56px;
      height: 32px;
      line-height: 32px;
      background: #266fe8;
      border-radius: 4px 4px 4px 4px;
    }
    .cancle {
      cursor: pointer;
      text-align: center;
      color: #333333;
      font-size: 14px;
      width: 56px;
      height: 32px;
      line-height: 32px;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #cccccc;
    }
  }
  .el-dialog {
    position: relative;
    .dialog_top {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 40px;
      line-height: 40px;
      padding-left: 24px;
      font-weight: 400;
      font-size: 18px;
      color: #333333;
      line-height: 40px;
      background: #ebeef5;
      border-radius: 4px 4px 0px 0px;
    }
    .box_content {
      width: 96%;
      height: 60px;
      // border: 1px solid red;
    }
    .elcheck {
      margin-right: 30px;
    }
    .box_content {
      display: flex;
      justify-content: flex-start;
    }
  }
}
</style>